export default {
  section: {
    general: 'Ogólny',
    data: 'Dane',
    limits: 'Granice',
  },
};
